import { isTargetSafe } from '@/services/redirect'
import { track } from '@/services/tracking'
import { Auth } from '@aws-amplify/auth'

/**
  * We want to know if we have all details for the user before completing registration
    since different identity providers give different set of information. One way to make sure
    is by using tc_consent value as an indication if all details are available since we set it
    just before completing registration
  * @param {CognitoUser} userData
  * @return {boolean}
*/
export const isAdditionalDetailsFilled = (userData) => userData.getSignInUserSession().getIdToken().payload.tc_consent === 'true'

/**
  * Sign in/Register with given SSO provider
  * @param {string} provider
*/
export const ssoSignIn = async (provider) => {
  let params = new URLSearchParams(document.location.search)
  const url = params.get('redirect')
  try {
    // Check URL is https & a zavamed/partner domain
    if (isTargetSafe(url)) {
      await Auth.federatedSignIn({ provider: provider, customState: url })
    } else {
      await Auth.federatedSignIn({ provider: provider })
    }
  } catch (error) {
    throw error
  }
}

export function extractStateUrl () {
  const params = new URLSearchParams(document.location.search)
  const state = params.get('state')

  if (state && state.indexOf('-') !== -1) {
    try {
      // Custom state returned from Cognito is stored after the hyphen in the state param
      let stateUrl = state.substring(state.indexOf('-') + 1)
      // Custom state is Base 16 encoded
      return Buffer.from(stateUrl, 'hex').toString()
    } catch (e) {
      track({ name: 'error', params: { module: 'auth', error_message: e.message, description: 'Failed to decode custom state (redirect query param) from Cognito' } })
    }
  }
  return null
}

/**
  * Get redirect URL from oauth customState (if present) and add it back to the URL query params in a new route object
  * @param {Route} to
*/
export function getRouteWithRestoredRedirect (to) {
  const stateUrl = extractStateUrl()

  if (stateUrl && !to.query.redirect) {
    return {
      ...to,
      query: { ...to.query, redirect: stateUrl }
    }
  }
  return null
}
